import { Link } from "react-router-dom";
import { ArrowDownUp } from "lucide-react";

// @ts-ignore
interface ColumnsProps {
  onClickDelete: (data: any) => void;
  handleUpdateDataClick: (data: any) => void;
  columnName: (data: any) => void;
  RequestCarringLoad: (data: any) => void;
  cancelRequest: (data: any) => void;
}

const ReadyLoadColumnData = ({
  onClickDelete,
  handleUpdateDataClick,
  columnName,
  RequestCarringLoad,
  cancelRequest,
}: ColumnsProps) => {
  return [
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("weight")}
        >
          <span onClick={() => columnName("loading_date")}>
            {" "}
            تاریخ بار گیری
          </span>

          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),

      accessorKey: "loading_date",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "درخواست",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => {
        const carried = cell?.row?.original?.carried;
        return (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              className={`flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md ${
                carried
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-zink-700 dark:text-zink-400"
                  : "bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              }`}
              onClick={(e) => {
                if (carried) {
                  e.preventDefault();
                  return;
                }
                const data = cell.row.original;
                RequestCarringLoad(data);
              }}
              style={carried ? { pointerEvents: "none" } : {}}
            >
              <span
                className={`rounded p-1 mx-auto w-40 ml-3 ${
                  carried
                    ? "bg-gray-400 text-white cursor-not-allowed z-50"
                    : "bg-green-600 text-white"
                }`}
              >
                {carried ? "درحال حمل" : "درخواست حمل بار"}
              </span>
            </Link>
          </div>
        );
      },
    },

    {
      header: "نام راننده",
      accessorKey: "driver_fullname",
      enableColumnFilter: false,
      cell: (cell: any) => {
        const driver_id = cell?.row?.original?.driver_fullname ? false : true;
        return (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              onClick={(e) => {
                if (driver_id) {
                  e.preventDefault();
                  return;
                }
                const data = cell.row.original;
                cancelRequest(data);
              }}
              style={driver_id ? { pointerEvents: "none" } : {}}
            >
              {driver_id ? (
                <span className="text-red-400 text-[12px]"> بدون راننده</span>
              ) : (
                <span className="text-green-600 bold font-bold dark:text-white">
                  {cell.getValue()}
                </span>
              )}
            </Link>
          </div>
        );
      },
    },
    {
      header: "نام کشاورز",
      accessorKey: "farmer_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all mx-auto duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "روستا",
      accessorKey: "village_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all mx-auto duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: () => (
        <div
          className="flex items-center gap-1"
          onClick={() => columnName("weight")}
        >
          <span onClick={() => columnName("loading_date")}> وزن بار </span>
          <ArrowDownUp className="text-blue-800" size={16} />
        </div>
      ),
      accessorKey: "weight",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },

    {
      header: "شماره همراه کشاورز",
      accessorKey: "farmer_phone",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "مبدا",
      accessorKey: "origin_city",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "مقصد",
      accessorKey: "destination_city",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },

    {
      header: "کرایه حمل تن",
      accessorKey: "carriage_fee_per_ton",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()?.toLocaleString("fa-IR")}
        </Link>
      ),
    },

    {
      header: "لغو",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => {
        const driver_id = cell?.row?.original?.driver_id ? false : true;
        return (
          <div className="flex gap-3">
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              className={`flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md ${
                driver_id
                  ? "bg-red-300 text-gray-500 cursor-not-allowed dark:bg-zink-700 dark:text-zink-400"
                  : "bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              }`}
              onClick={(e) => {
                if (driver_id) {
                  e.preventDefault();
                  return;
                }
                const data = cell.row.original;
                cancelRequest(data);
              }}
              style={driver_id ? { pointerEvents: "none" } : {}}
            >
              <span
                className={`rounded p-1 mx-auto w-40 ml-3 ${
                  driver_id
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-green-600 text-white"
                }`}
              >
                {driver_id ? "لغو حمل" : "لغو حمل"}
              </span>
            </Link>
          </div>
        );
      },
    },
    {
      header: "عملیات",
      enableColumnFilter: false,
      enableSorting: true,
      id: "operations",
      cell: (cell: any) => (
        <div className="flex gap-3">
          <>
            <Link
              to="#!"
              data-modal-target="addEmployeeModal"
              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                handleUpdateDataClick(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-green-600 text-white">
                ویرایش
              </span>
            </Link>
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <span className="rounded p-1 px-1 w-20 ml-3 bg-red-600 text-white">
                حذف
              </span>
            </Link>
          </>
        </div>
      ),
    },
    {
      header: "سال زراعی",
      accessorKey: "crop_year_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()?.toLocaleString("fa-IR")}
        </Link>
      ),
    },
  ];
};

export default ReadyLoadColumnData;
